<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} PRODUCT</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <span class="px-2" style="font-size:12px">Active?</span> 
        <vs-switch color="primary" color-off="danger" v-model="dataIsActive">
        <span slot="on">On</span>
        <span slot="off">Off</span>
        </vs-switch>
        <span class="px-2" style="font-size:12px">Paid?</span> 
        <vs-switch color="primary" color-off="danger" v-model="dataIsPaid">
        <span slot="on">On</span>
        <span slot="off">Off</span>
        </vs-switch>
        <!-- Value -->
                  <div class="mt-5 w-full">
                    <p class="w-full" style="font-size:85%">
                      &nbsp;Deadline
                      <datepicker :inline="false" v-model="dataDt"></datepicker>
                    </p>
                  </div>
        <div class="vx-col w-full">
        <vs-input label="Amount (RON)" v-model="dataAmount" class="mt-5 w-full" name="amount" v-validate="'decimal'" />
        <span class="text-danger text-sm" v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
          </div>
        </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>
 
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from '@/axios.js'
import Datepicker from 'vuejs-datepicker'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    Datepicker
  },
  data () { 
    return {  
      dataIdOperation:true,  
      dataIsActive:true,  
      dataIsPaid:false,  
      dataId: null,
      dataDt: null,
      dataAmount: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 1) { 
        this.initValues()
        const { idoperation } = JSON.parse(JSON.stringify(this.data))
        this.dataIdOperation = idoperation,
        this.$validator.reset()
        this.dataId = null
      } else {
        console.log(this.data);
        const { id, isactive,idoperation,paid,amount,date } = JSON.parse(JSON.stringify(this.data))
        this.dataIdOperation = idoperation,
        this.dataId = id,
        this.dataIsActive = isactive,
        this.dataIsPaid = paid,
        this.dataDt = date,
        this.dataAmount = amount,
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
  },
  methods: {
    initValues () {
      if (this.data.id) return
        this.dataAmount = null,
        this.dataIsActive = true,
        this.dataIsPaid = false
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let obj = {}
            obj = {
              id: this.dataId,
              date: this.dataDt,
              amount: this.dataAmount,
              isactive: this.dataIsActive,
              ispaid: this.dataIsPaid,
              idoperation: this.dataIdOperation
          }
          console.log(obj)
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('dataListProduct/updateItem', obj).catch(err => { console.error(err) })
            this.$vs.notify({ 
              color: 'success',
              title: 'Payment Updated!',
              text: 'The Payment was successfully edited'
            })
          }
          else {
            delete obj.id
            this.$store.dispatch('dataListProduct/createItem', obj).catch(err => { console.error(err) })
            this.$vs.notify({
              color: 'success',
              title: 'Payment Created!',
              text: 'The Payment was successfully added'
            })
          }
          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
